import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import React from 'react';
import ImageUploading from 'react-images-uploading';
import { t } from '../locales/translate.js';
import { useParams } from "react-router-dom";

function Element({ apiCall, user }) {
    const { id } = useParams(); // Get the report ID from the URL

    // 'game_qr' => 'required|string|max:255',
    // 'organ_qr' => 'nullable|string|max:255',
    // 'game_id' => 'required|exists:games,id',
    // 'depot_id' => 'required|nullable|exists:depots,id',
    // 'weight' => 'nullable|integer',
    // 'notes' => 'nullable|string',
    // 'images' => 'nullable|array',

    const [loading, setLoading] = useState(true);
    const [note, setNote] = useState("");
    const [images, setImages] = React.useState([]);
    const [data, setData] = useState({});

    //image errors
    const [imageErrors, setImageErrors] = useState([]);
    const maxNumber = 5;
    const onChange = (imageList, addUpdateIndex) => {
        // data for submit
        console.log(imageList, addUpdateIndex);
        setImages(imageList);
    };

    const navigate = useNavigate();
  
    useEffect(() => {
        // Fetch reports data when the component mounts
        apiCall("GET", `reports/${id}/scrap`)
            .then(({ response, error }) => {
                if (error) {
                    console.error("Error fetching scrap data:", error);
                } else {
                    console.log("Scrap data:", response);
                    setData(response);
                    setNote(response?.notes || "");
                    setImages(response?.images || []);
                }
                setLoading(false);
            });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiCall]);

    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    const submitReport = (e, addmore = false) => {

        e.preventDefault();
        setError(null);
        setSuccess(null);


        const data = {
            notes: note,
            images: images.map(image => image.data_url || image), // Use data_url if available, otherwise use the image object
        };


        apiCall("PUT", `reports/${id}/scrap`, data)
            .then(({ response, error }) => {
                if (error) {
                    console.log(response);
                    console.error(response);
                    setError(error);
                    return;
                }

                setSuccess(t('report_added_successfully'));
                navigate("/transport");
            })
            .catch(err => {
                console.error("Error adding report:", err);
                setError(t('failed_to_add_report'));
            });

    }

    if (loading) {
        return <div>{t('loading')}</div>;
    }


    if (user?.role_id !== 3) {
        return (
            <div className="col-sm-12">
                <div className="card">
                    <div className="card-header">
                        <h5>
                            {t('transport_not_allowed')}
                        </h5>
                    </div>
                    <div className="card-body">
                        <p>{t('transport_not_allowed_message')}</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="card create-project-form custom-input">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h5>{t('scrap_report')}</h5>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-12">
                        <div className="row g-3 needs-validation" noValidate="">

                            <div className="col-md-6">
                                <label className="form-label" htmlFor="projectName">{t('game_qr')}</label>
                                <input className="form-control" id="projectName" type="text" name="game_qr" placeholder={t('game_qr_placeholder')}  value={ data.game_qr} maxLength={10} disabled />
                            </div>
                                 <div className="col-md-6">
                                <label className="form-label" htmlFor="projectName">{t('organ_qr')}</label>
                                <input className="form-control" id="projectName" type="text" name="organ_qr" placeholder={t('organ_qr_placeholder')}  value={ data.organ_qr} maxLength={10} disabled />
                            </div>
                            <div className="col-md-12">
                                <label className="form-label" htmlFor="projectName">{t('depot')}</label>
                                <input className="form-control" id="projectName" type="text" name="game_qr" value={ data.depot_name } maxLength={10} disabled />
                            </div>

                             
                            <div className="col-12">
                                <label className="form-label" htmlFor="validationTextarea">{t('reason_for_scrapping')}</label>
                                <textarea className="form-control" id="validationTextarea" placeholder={t('enter_project_details')} required rows="4" name="note" value={ note } onChange={(e) => setNote(e.target.value)}>

                                </textarea>
                                <div className="invalid-feedback">{t('please_enter_project_details')}</div>
                            </div>

                            <ImageUploading
                                value={images}
                                multiple
                                onChange={onChange}
                                maxFileSize={25 * 1024 * 1024} // 25MB
                                onError={(errors) => setImageErrors(errors)}
                                maxNumber={maxNumber}
                                inputProps={{ capture: "environment" }}
                                dataURLKey="data_url"
                            >
                                {({
                                    imageList,
                                    onImageUpload,
                                    onImageRemoveAll,
                                    onImageUpdate,
                                    onImageRemove,
                                    isDragging,
                                    dragProps
                                }) => (
                                    // write your building UI
                                    <div className="upload__image-wrapper">
                                        <div className="buttons">
                                            <button className="btn btn-secondary"
                                                style={isDragging ? { color: "red" } : null}
                                                onClick={onImageUpload}
                                                {...dragProps}
                                            >
                                                <i className="fa fa-camera"></i> {t('click_or_drop_here')}
                                            </button>

                                            {images && images.length > 0 && (<button className="btn btn-secondary" onClick={onImageRemoveAll}>{t('remove_all_images')}</button>)}
                                        </div>

                                        <div className="photos transport">
                                            {imageList.map((image, index) => (
                                                <div key={index} className="image-item" style={{ backgroundImage: image.data_url ? `url(${image.data_url})` : `url(${process.env.REACT_APP_API_HOST}/storage/${image})` }}>
                                                    <button onClick={() => onImageUpdate(index)}>{t('update')}</button>
                                                    <button onClick={() => onImageRemove(index)}>{t('remove')}</button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </ImageUploading>

                            {imageErrors && (
                                <div>
                                    {imageErrors.maxNumber && <span className="alert alert-danger">{t('number_of_selected_images_exceed_maxNumber')}</span>}
                                    {imageErrors.acceptType && <span className="alert alert-danger">{t('your_selected_file_type_is_not_allow')}</span>}
                                    {imageErrors.maxFileSize && <span className="alert alert-danger">{t('selected_file_size_exceed_maxFileSize')}</span>}
                                    {imageErrors.resolution && <span className="alert alert-danger">{t('selected_file_is_not_match_your_desired_resolution')}</span>}
                                </div>
                            )}


                            {error && <div className="alert alert-danger">{error}</div>}
                            {success && <div className="alert alert-success">{success}</div>}

                            <div className="col-12">
                                <div className="common-flex justify-content-end">
                                    <button className="btn btn-primary" type="submit" onClick={submitReport}>{t('scrap')}</button>
                                    <Link to="/transport" className="btn btn-secondary" type="button">{t('cancel')}</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default Element;
